module.exports = __webpack_public_path__ + "static/img/1.25933a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/1.png
// module id = NX7t
// module chunks = 0